import { render, staticRenderFns } from "./EditItemAutocomplete.vue?vue&type=template&id=b84f5ff2"
import script from "./EditItemAutocomplete.vue?vue&type=script&lang=js"
export * from "./EditItemAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports